import router from "../router";

export default {
  namespaced: true,
  state: {
    data: [],
    notification: {},
  },
  mutations: {
    SET_DATA: (state, data) => {
      state.data = data;
    },
    SET_NOTIFICATION: (state, data) => {
      state.notification = data;
    },
  },
  actions: {
    all: function ({ commit, dispatch }) {
      commit("SET_LOADING_STATE", true, { root: true });
      this.$http
        .get("NotificationsSettings")
        .then((res) => {
          if (res.status == 200) {
            commit("SET_DATA", res.data.data);
            commit("SET_LOADING_STATE", false, { root: true });
          }
        })
        .catch((err) => {
          commit("SET_LOADING_STATE", false, { root: true });
          dispatch(
            "setError",
            {
              message: err.message,
              code: 1,
            },
            { root: true }
          );
        });
    },
    get: function ({ commit, dispatch }, id) {
      this.$http
        .get(`NotificationsSettings/${id}`)
        .then((res) => {
          if (res.status == 200) {
            commit("SET_NOTIFICATION", res.data.data);
            commit("SET_LOADING_STATE", false, { root: true });
          }
        })
        .catch((err) => {
          commit("SET_LOADING_STATE", false, { root: true });
          dispatch(
            "setError",
            {
              message: err.message,
              code: 1,
            },
            { root: true }
          );
        });
    },
    update: function ({ commit, dispatch }, notification) {
      const vm = this;
      return new Promise(function (resolve) {
        return vm.$http
          .put(`NotificationsSettings/${notification.id}`, notification)
          .then((res) => {
            if (res.status == 200) {
              commit("SET_SAVING_STATE", false, { root: true });
              router.push("/admin/notifications-settings");
              return resolve(true);
            }
          })
          .catch((err) => {
            commit("SET_SAVING_STATE", false, { root: true });
            dispatch(
              "setError",
              {
                message:
                  ((err.data || {}).error || {}).message ||
                  "Something went wrong. Please refresh the page and try again",
                code: 1,
              },
              { root: true }
            );
            return resolve(false);
          });
      });
    },
  },
};
